import Epar from './Epar';

export default class Registration {
	epar: Epar | null;

	constructor(epar: Epar | null) {
		this.epar = epar;
	}
}
